import { Layout } from 'antd';
import { Outlet } from 'react-router-dom';
import classNames from 'classnames';

import { AccordionSideMenu } from '@Components/index';
import { useRequestFromPage } from '@Hooks/index';
import { usePageType } from '@Hooks/usePageType';

import styles from './mobile-layout.module.css';

const { Content } = Layout;

interface MobileLayoutProps {
  children: JSX.Element | JSX.Element[];
}

const MobileLayout: React.FC<MobileLayoutProps> = ({ children }) => {
  const pageType = usePageType();
  const isRequestFormPage = useRequestFromPage();
  const pageTypesWithStickyFooter = ['myRequests', 'approvals'];
  const hasFooter = pageType && pageTypesWithStickyFooter.includes(pageType);

  return (
    <Layout>
      {children}
      <Content
        className={classNames(styles.contentSection, {
          [styles.noBottomMargin]: pageType === undefined,
          [styles.contentHasNotFooter]: hasFooter === false,
        })}
        id="scrollableList"
      >
        <Outlet context={{ isRequestFormPage }} />
      </Content>
      {hasFooter && <AccordionSideMenu pageType={pageType} isMobile />}
    </Layout>
  );
};

export default MobileLayout;
